import type * as Scrivito from "scrivito";

export const isVideoObj = (obj: Scrivito.Obj) => {
  if (!obj) {
    return false;
  }

  const contentType = obj.contentType();
  if (!contentType) {
    return false;
  }

  return contentType.startsWith("video/");
};
